import { inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { CreatePostComponent } from '@app/pages/posts/pages/create-post/create-post.component';
import { ConfirmAlertComponent, EConfirmButton, AlertConfigModel } from '@shared/components/confirm-alert/confirm-alert.component';
import { DRAFT_KEY, DraftModel } from '@shared/helper/draft/models/draft.model';
import { LocalRepository } from '@shared/helper/local-repository';
import { Observable, map, of } from 'rxjs';


export const postGuard: CanDeactivateFn<CreatePostComponent> = (component: CreatePostComponent):
Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const dialog: MatDialog = inject(MatDialog);
  const bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  const localRepository: LocalRepository = inject(LocalRepository);

  const dialogInfo: AlertConfigModel = {
    cancelButtonText: 'بله می‌روم',
    confirmButtonText: 'خیر ادامه می‌دهم',
    title: 'می‌خواهید به صفحۀ دیگری بروید؟',
  };

  if (component?.postInfoForm?.dirty) {
    if (localRepository.IsInMobile) {
      const bottomSheetRef = bottomSheet.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-bottomsheet'
      });

      return bottomSheetRef.afterDismissed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    } else {
      const dialogRef = dialog.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-dialog'
      });

      return dialogRef.afterClosed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    }
  }
  return of(true);
};

function handleAction(action: EConfirmButton, component: CreatePostComponent, localRepository: LocalRepository): boolean {
  if (action === EConfirmButton.CANCLE) {
    const data: DraftModel = {
      post: {
        draftKey: 'post',
        body: component.postInfoForm.controls['body'].value,
        title: component.postInfoForm.controls['title'].value,
        preview: component.postInfoForm.controls['preview'].value,
        attachedBooks: component.attachedBooks,
        tags: component.tags
      }
    };
    let existData: DraftModel = JSON.parse(localRepository.getLocalItem(DRAFT_KEY)!) || new DraftModel();
    if (!existData) {
      existData = new DraftModel();
    }
    existData.post = data.post;
    localRepository.setLocalItem(DRAFT_KEY, JSON.stringify(existData));
    return true;
  } else if (action === EConfirmButton.CONFIRM) {
    return false;
  } else {
    return false;
  }
}
